module.exports = __webpack_public_path__ + "static/media/lilyar.86c2ec6b.png";